import { Framework } from '@/framework/instance';
import { IFont, ILayerProps } from '@/version-types';

export class Font extends Framework {
    /**
     * 获取字体
     *
     * @param fontName - 字体名称
     */
    get(fontName: string) {
        return this.framework.getFont(fontName);
    }

    /**
     * 获取字体列表
     */
    getList() {
        return this.framework.getFontList();
    }

    /**
     * 设置字体列表
     *
     * @param fontList - 字体列表
     */
    setList(fontList: IFont[]) {
        this.framework.setFontList(fontList);
    }

    /**
     * 创建文本字体子集
     *
     * @param texts - 文本
     * @param fontName - 字体名称
     */
    async createTextSubset(texts: string, fontName: string) {
        return await this.framework.createTextSubset(texts, fontName);
    }

    /**
     * 获取字体子集 Base64 编码
     *
     * @param subsetName - 字体子集名称
     */
    getSubsetBase64(subsetName: string) {
        return this.framework.getSubsetBase64(subsetName);
    }

    /**
     * 获取正在使用的字体列表
     *
     * @param originIndex - 舞台原始索引
     */
    getUsingList(originIndex: number): IFont[];

    /**
     * 获取正在使用的字体列表
     *
     * @param layers - 图层数据
     */
    getUsingList(layers: ILayerProps[]): IFont[];
    getUsingList(param: any): IFont[] {
        return this.framework.getUsingFontList(param);
    }

    /**
     * 创建字体样式
     *
     * @param fontName - 字体名称
     * @param fontBase64 - 字体 Base64 编码
     */
    createStyle(fontName: string, fontBase64: string) {
        return this.framework.createFontStyle(fontName, fontBase64);
    }

    /**
     * 创建字体子集
     *
     * @param originIndex - 舞台原始索引
     * @param refreshLayer - 是否重新渲染图层，【下载时不需要重新渲染】
     */
    async createSubset(originIndex: number, refreshLayer: boolean);

    /**
     * 创建字体子集
     *
     * @param layers - 图层数据
     * @param refreshLayer - 是否重新渲染图层，【下载时不需要重新渲染】
     */
    async createSubset(layers: ILayerProps[], refreshLayer: boolean);
    async createSubset(param: any, refreshLayer) {
        return await this.framework.createFontFamilySubset(param, refreshLayer);
    }

    /**
     * 注册全量字体
     *
     * @param layer - 图层属性
     * @param font_name - 字体名称
     * @param showLoading - 可选；是否显示加载动画；默认值为 `true`
     * @returns 字体 material_id
     */
    async register(layer: ILayerProps, fontName: string, showLoading: boolean = true) {
        return await this.framework.registerFont(layer, fontName, showLoading);
    }

    /**
     * 异步加载字体
     *
     * @param fontName - 字体名称
     * @param zip_url - 字体 zip 地址
     */
    async loadFontAsync(fontName: string, zipUrl: string) {
        return await this.framework.loadFont(fontName, zipUrl);
    }
}
